import { GasType } from './useGetGasData';
import GasChart from './GasChart';
import { Dayjs } from 'dayjs';
import { DateType } from '../../const';

interface AirProps {
  gasList?: GasType[];
  timeResolution: DateType;
  dateValue?: [Dayjs | null, Dayjs | null] | null;
}

const Air = ({ gasList, timeResolution, dateValue }: AirProps) => {
  return (
    <>
      {gasList?.map((item, index) => (
        <GasChart
          gasType={item}
          showTitle={index === 0}
          key={item}
          timeResolution={timeResolution}
          dateValue={dateValue}
        />
      ))}
    </>
  );
};

export default Air;
